var map = {
	"./default-branding-apac-prod.json": 528,
	"./default-branding-dev.json": 529,
	"./default-branding-dit.json": 530,
	"./default-branding-emea-dev.json": 531,
	"./default-branding-emea-prod.json": 532,
	"./default-branding-emea-staging.json": 533,
	"./default-branding-fit.json": 534,
	"./default-branding-iat.json": 535,
	"./default-branding-ipe.json": 536,
	"./default-branding-prod.json": 537,
	"./default-branding-uat.json": 538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 527;